import React from 'react';
import { Check, Wrench } from 'lucide-react';
import { motion } from 'framer-motion';
const tomes = [{
  num: '01',
  title: 'MÉTODO SUEÑO VITAL',
  desc: 'Entiende cómo funciona el sueño de tu bebé desde su biología real. Por qué se despierta, cuánto es normal según su edad y qué puedes hacer cada noche para que tanto él como tú descanséis mejor.',
  tool: 'Log de Sueño de 7 días'
}, {
  num: '02',
  title: 'PROTOCOLO ALIVIO DIGESTIVO',
  desc: 'El llanto de gases, cólicos y reflujo tiene señales específicas que puedes aprender a identificar. Este tomo te da un protocolo claro para saber qué tipo de llanto es y qué hacer en cada caso.',
  tool: 'Semáforo del Llanto Digestivo'
}, {
  num: '03',
  title: 'SEGURIDAD INMEDIATA (SOS)',
  desc: 'Los accidentes más comunes del primer año, cómo prevenirlos y qué hacer paso a paso si ocurren. Prepararte antes de que pase cualquier cosa es la mejor forma de reducir el miedo.',
  tool: 'Ficha de Emergencia "Pega en la nevera"'
}, {
  num: '04',
  title: 'CONEXIÓN COGNITIVA',
  desc: 'Qué hitos son normales en cada etapa, qué variaciones son completamente esperables y cuáles merecen consulta con el pediatra. Deja de comparar y empieza a entender exactamente en qué momento está tu bebé.',
  tool: 'Tabla de Hitos del Primer Año'
}, {
  num: '05',
  title: 'ARMONÍA EN CASA (POSTPARTO)',
  desc: 'El postparto no es solo físico. Es emocional, relacional y logístico. Este tomo aborda la salud mental de los padres, el reparto de la carga y cómo mantener la relación de pareja cuando todo lo consume el bebé.',
  tool: 'Contrato de Coparentalidad de 4 semanas'
}, {
  num: '06',
  title: 'NUTRICIÓN Y DESTETE (BLW)',
  desc: 'Todo lo que necesitas saber sobre la alimentación complementaria: cuándo empezar, cómo hacerlo de forma segura, qué alimentos introducir primero y cómo gestionar el miedo a que se atragante.',
  tool: 'Calendario "Mis Primeros 100 Alimentos"'
}];
export const Tomes = () => <section className="bg-brand-dark py-[48px] px-5 md:px-10" data-id="element-57">
    <div className="max-w-[1040px] mx-auto" data-id="element-58">
      <div className="flex flex-col items-center mb-8" data-id="element-59">
        <h2 className="font-playfair font-bold text-[40px] text-white text-center mb-[6px]" data-id="element-60">
          El Sistema Completo
        </h2>
        <div className="w-[80px] h-[3px] bg-brand-accentPremium mb-[10px]" data-id="element-61"></div>
        <h3 className="font-inter font-bold text-[13px] text-brand-accentPremium text-center tracking-[3px] uppercase" data-id="element-62">
          6 Tomos Completos
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]" data-id="element-63">
        {tomes.map((t, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-[14px] p-[36px_32px] hover:bg-white/9 hover:border-brand-accentPremium/30 transition-all duration-200 relative overflow-hidden group" data-id="element-64">
            <div className="font-playfair font-bold text-[72px] text-brand-accentPremium/20 absolute top-[-10px] right-[20px] leading-none pointer-events-none z-0" data-id="element-65">
              {t.num}
            </div>
            <div className="bg-brand-accentPremium/16 border border-brand-accentPremium/40 text-brand-accentPremium font-inter font-bold text-[11px] tracking-[2.5px] uppercase px-[14px] py-[5px] rounded-[20px] inline-block mb-[14px] relative z-10" data-id="element-66">
              TOMO {i + 1}
            </div>
            <h4 className="font-playfair font-bold text-[24px] text-white mb-[16px] leading-[1.25] relative z-10" data-id="element-67">
              {t.title}
            </h4>
            <p className="font-inter text-[15px] text-white/65 leading-[1.68] mb-[24px] relative z-10" data-id="element-68">
              {t.desc}
            </p>
            <div className="h-[1px] bg-white/10 mb-[20px] relative z-10" data-id="element-69" />
            <div className="bg-brand-accentExtra/12 border border-brand-accentExtra/30 rounded-[8px] px-[18px] py-[14px] flex items-center gap-[10px] relative z-10" data-id="element-70">
              <Wrench className="w-[16px] h-[16px] text-brand-accentExtra shrink-0" data-id="element-71" />
              <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2" data-id="element-72">
                <span className="font-inter font-bold text-[12px] text-brand-accentExtra tracking-[0.5px]" data-id="element-73">
                  Incluye:
                </span>
                <span className="font-inter font-semibold text-[14px] text-white" data-id="element-74">
                  {t.tool}
                </span>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-white/4 border-t border-white/10 p-[28px_32px] mt-[32px] rounded-b-[14px] flex flex-wrap justify-center gap-[12px_24px]" data-id="element-75">
        {['Información clara y sin tecnicismos', 'Protocolos listos para aplicar hoy', 'Herramienta práctica incluida', 'Adaptado a la realidad imperfecta'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-76">
            <Check className="w-4 h-4 text-brand-accentExtra" data-id="element-77" />
            <span className="font-inter text-[14px] text-white/65" data-id="element-78">{item}</span>
          </div>)}
      </div>
    </div>
  </section>;
const bonuses = [{
  num: 1,
  title: 'TU GUÍA PARA NO PERDERTE',
  desc: 'El mapa completo del sistema. Rutas por edad y urgencia para saber siempre qué hacer a continuación.',
  value: '9,97€'
}, {
  num: 2,
  title: 'LO NORMAL EN CADA MES',
  desc: 'Guía de tranquilidad mes a mes. Entiende qué es normal y deja de preocuparte innecesariamente.',
  value: '7,97€'
}, {
  num: 3,
  title: 'ETAPAS DEL PRIMER AÑO',
  desc: 'Las cuatro etapas clave del primer año. Entiende los retos actuales y prepárate para lo que viene.',
  value: '7,97€'
}, {
  num: 4,
  title: 'KIT DEL DÍA A DÍA',
  desc: 'Logística real: rutinas, organización del hogar y reparto de tareas para eliminar el caos diario.',
  value: '19,00€'
}, {
  num: 5,
  title: 'MENOS ESTRÉS CON TU BEBÉ',
  desc: 'Herramientas para bajar la carga mental y gestionar el agotamiento. Porque tú también importas.',
  value: '9,97€'
}, {
  num: 6,
  title: 'RESPIRA UN POCO',
  desc: 'Técnicas de calma inmediata para momentos críticos. El apoyo que necesitas cuando sientes que no puedes más.',
  value: '9,97€'
}];
export const Bonuses = () => <section className="bg-brand-bgAlt py-[48px] px-5 md:px-10" data-id="element-79">
    <div className="max-w-[720px] mx-auto" data-id="element-80">
      <div className="flex flex-col items-center mb-[28px]" data-id="element-81">
        <h2 className="font-playfair font-bold text-[36px] text-brand-text text-center mb-[6px]" data-id="element-82">
          Bonos Incluidos
        </h2>
        <div className="w-[64px] h-[3px] bg-brand-accentPremium mb-[10px]" data-id="element-83"></div>
        <h3 className="font-inter font-semibold text-[13px] text-brand-textSec text-center tracking-[2px] uppercase" data-id="element-84">
          6 Bonos Estratégicos — Siempre Incluidos
        </h3>
      </div>

      <div className="flex flex-col gap-[10px]" data-id="element-85">
        {bonuses.map((b, i) => <div key={i} className="bg-white rounded-r-[12px] p-[16px_24px] shadow-[0_2px_10px_rgba(15,30,58,0.05)] border border-brand-borderDorado border-l-[4px] border-l-brand-accent flex flex-row items-center" data-id="element-86">
            <div className="w-[40px] h-[40px] rounded-full bg-brand-dark text-white font-inter font-bold text-[15px] flex items-center justify-center shrink-0 mr-[20px]" data-id="element-87">
              {b.num}
            </div>
            <div className="flex-grow" data-id="element-88">
              <div className="bg-brand-paleBlue border border-brand-accent/20 text-brand-accent font-inter font-bold text-[10px] tracking-[1.5px] uppercase px-[10px] py-[3px] rounded-[10px] inline-block mb-[4px]" data-id="element-89">
                BONO {b.num}
              </div>
              <h4 className="font-inter font-semibold text-[16px] text-brand-text mb-[2px]" data-id="element-90">
                {b.title}
              </h4>
              <p className="font-inter text-[14px] text-brand-textSec leading-[1.5]" data-id="element-91">
                {b.desc}
              </p>
            </div>
            <div className="flex flex-col items-end gap-[4px] shrink-0 ml-[20px]" data-id="element-92">
              <span className="font-inter text-[13px] text-brand-textStrikethrough line-through" data-id="element-93">
                {b.value}
              </span>
              <span className="bg-brand-dark text-white font-inter font-bold text-[12px] px-[14px] py-[5px] rounded-[16px]" data-id="element-94">
                GRATIS
              </span>
            </div>
          </div>)}
      </div>

      <div className="bg-brand-dark rounded-[12px] p-[20px_32px] mt-[24px] flex flex-row justify-between items-center" data-id="element-95">
        <div className="flex flex-col" data-id="element-96">
          <div className="font-inter text-[16px] text-white/60" data-id="element-97">
            Valor total bonos:
          </div>
          <div className="font-playfair text-[26px] text-white/35 line-through" data-id="element-98">
            55,82€
          </div>
        </div>
        <div className="font-inter font-bold text-[22px] text-brand-accentPremium" data-id="element-99">
          GRATIS con tu MegaPack
        </div>
      </div>

      <div className="mt-[36px] flex justify-center" data-id="element-100">
        <button onClick={() => document.getElementById('pricing-section')?.scrollIntoView({
        behavior: 'smooth'
      })} className="bg-brand-accent hover:bg-brand-accentHover text-white font-inter font-bold text-[18px] px-[56px] py-[20px] rounded-[10px] shadow-[0_8px_24px_rgba(74,114,184,0.38)] hover:shadow-[0_10px_30px_rgba(74,114,184,0.48)] transition-all duration-250 transform hover:-translate-y-[2px] w-full md:w-fit" data-id="element-101">
          → QUIERO ENTENDER A MI BEBÉ HOY
        </button>
      </div>
    </div>
  </section>;
export const ScarcitySection = () => <section className="relative bg-gradient-to-b from-brand-dark via-[#1a0e10] to-brand-dark py-[48px] px-5 md:px-10 overflow-hidden" data-id="element-102">
    {/* Premium ambient glow effects */}
    <div className="absolute inset-0 pointer-events-none" data-id="element-103">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-red-600/10 rounded-full blur-[120px]" data-id="element-104" />
      <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-red-500/5 rounded-full blur-[80px]" data-id="element-105" />
    </div>

    {/* Subtle grain/noise overlay */}
    <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
    backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
    backgroundSize: '24px 24px'
  }} data-id="element-106" />

    <div className="relative max-w-[820px] mx-auto" data-id="element-107">
      {/* LIVE indicator badge */}
      <div className="flex justify-center mb-6" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 bg-red-600/15 border border-red-500/40 backdrop-blur-sm px-4 py-1.5 rounded-full" data-id="element-109">
          <motion.div animate={{
          scale: [1, 1.4, 1],
          opacity: [1, 0.5, 1]
        }} transition={{
          duration: 1.2,
          repeat: Infinity
        }} className="w-2 h-2 bg-red-500 rounded-full shadow-[0_0_12px_rgba(239,68,68,0.9)]" data-id="element-110" />
          <span className="font-inter font-bold text-[10px] tracking-[2px] uppercase text-red-300" data-id="element-111">
            EN VIVO · Actualizado ahora
          </span>
        </motion.div>
      </div>

      {/* Main premium card */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7
    }} viewport={{
      once: true
    }} className="relative bg-gradient-to-br from-[#1f1216] via-[#180b0e] to-[#1f1216] border border-red-900/40 rounded-[20px] p-[40px] md:p-[56px] shadow-[0_20px_70px_rgba(220,38,38,0.25),0_0_0_1px_rgba(220,38,38,0.1)_inset]" data-id="element-112">
        {/* Top accent line */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[60%] h-[1px] bg-gradient-to-r from-transparent via-red-500/60 to-transparent" data-id="element-113" />

        {/* Header */}
        <div className="text-center mb-10" data-id="element-114">
          <div className="font-inter font-bold text-[10px] md:text-[11px] tracking-[3px] uppercase text-red-400/80 mb-3" data-id="element-115">
            ⚠ Acceso Limitado · Precio de Lanzamiento
          </div>
          <h2 className="font-playfair font-bold text-[26px] md:text-[36px] text-white leading-[1.2] mb-3" data-id="element-116">
            Cupos al precio de lanzamiento
          </h2>
          <p className="font-playfair italic text-[15px] md:text-[17px] text-brand-accentPremium" data-id="element-117">
            del Sistema{' '}
            <span className="not-italic font-bold tracking-wide" data-id="element-118">
              CÓMO ENTENDER A TU BEBÉ
            </span>
          </p>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-3 gap-3 md:gap-4 mb-8" data-id="element-119">
          <div className="bg-white/[0.03] border border-white/10 rounded-[12px] p-4 flex flex-col items-center justify-center text-center min-h-[100px] md:min-h-[120px]" data-id="element-120">
            <div className="font-playfair font-bold text-[28px] md:text-[36px] text-red-400 leading-none mb-1" data-id="element-121">
              72%
            </div>
            <div className="font-inter text-[10px] md:text-[11px] text-white/50 uppercase tracking-wider leading-tight" data-id="element-122">
              Reservados
            </div>
          </div>
          <div className="bg-red-600/10 border border-red-500/30 rounded-[12px] p-4 flex flex-col items-center justify-center text-center min-h-[100px] md:min-h-[120px]" data-id="element-123">
            <div className="font-playfair font-bold text-[28px] md:text-[36px] text-white leading-none mb-1" data-id="element-124">
              28
            </div>
            <div className="font-inter text-[10px] md:text-[11px] text-red-300 uppercase tracking-wider leading-tight" data-id="element-125">
              Disponibles
            </div>
          </div>
          <div className="bg-white/[0.03] border border-white/10 rounded-[12px] p-4 flex flex-col items-center justify-center text-center min-h-[100px] md:min-h-[120px]" data-id="element-126">
            <div className="font-playfair font-bold text-[28px] md:text-[36px] text-brand-accentPremium leading-none mb-1" data-id="element-127">
              +10€
            </div>
            <div className="font-inter text-[10px] md:text-[11px] text-white/50 uppercase tracking-wider leading-tight" data-id="element-128">
              Sube después
            </div>
          </div>
        </div>

        {/* Premium progress bar */}
        <div className="mb-8" data-id="element-129">
          <div className="flex justify-between items-center mb-3" data-id="element-130">
            <span className="font-inter font-bold text-[12px] tracking-[1.5px] uppercase text-white/70" data-id="element-131">
              Progreso de cupos
            </span>
            <span className="font-inter font-bold text-[12px] text-red-400" data-id="element-132">
              72 / 100
            </span>
          </div>
          <div className="relative h-[14px] w-full bg-black/40 rounded-full overflow-hidden border border-white/5 shadow-[inset_0_2px_8px_rgba(0,0,0,0.6)]" data-id="element-133">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '72%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.8,
            ease: [0.16, 1, 0.3, 1]
          }} className="relative h-full rounded-full bg-gradient-to-r from-red-700 via-red-500 to-red-400 shadow-[0_0_20px_rgba(239,68,68,0.6)]" data-id="element-134">
              {/* Glow at the leading edge */}
              <motion.div animate={{
              opacity: [0.4, 1, 0.4]
            }} transition={{
              duration: 1.8,
              repeat: Infinity
            }} className="absolute right-0 top-1/2 -translate-y-1/2 w-3 h-3 bg-white rounded-full shadow-[0_0_16px_rgba(255,255,255,0.9)]" data-id="element-135" />
              {/* Animated shimmer */}
              <motion.div animate={{
              x: ['-100%', '200%']
            }} transition={{
              duration: 2.5,
              repeat: Infinity,
              ease: 'linear'
            }} className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-136" />
            </motion.div>
          </div>
        </div>

        {/* Caption */}
        <div className="bg-black/30 border-l-[3px] border-red-500 rounded-r-[8px] px-5 py-4 mb-8" data-id="element-137">
          <p className="font-inter text-[14px] md:text-[15px] text-white/75 leading-[1.65]" data-id="element-138">
            Solo{' '}
            <span className="text-white font-bold" data-id="element-139">28 de cada 100 padres</span>{' '}
            pueden acceder aún al precio de lanzamiento. Cuando se agoten,{' '}
            <span className="text-red-400 font-bold" data-id="element-140">
              el precio sube definitivamente +10€
            </span>
            . Sin excepciones, sin segundas oportunidades.
          </p>
        </div>

        {/* CTA */}
        <button onClick={() => document.getElementById('pricing-section')?.scrollIntoView({
        behavior: 'smooth'
      })} className="group w-full bg-gradient-to-r from-red-600 to-red-500 hover:from-red-500 hover:to-red-400 text-white font-inter font-bold text-[15px] md:text-[17px] py-[18px] px-6 rounded-[12px] shadow-[0_10px_30px_rgba(220,38,38,0.4)] hover:shadow-[0_14px_40px_rgba(220,38,38,0.55)] transition-all duration-300 transform hover:-translate-y-[2px] flex items-center justify-center gap-2 tracking-wide" data-id="element-141">
          🔴 RESERVAR MI CUPO AL PRECIO DE LANZAMIENTO
          <span className="transition-transform group-hover:translate-x-1" data-id="element-142">
            →
          </span>
        </button>

        <p className="text-center font-inter text-[11px] text-white/40 mt-4 tracking-wider" data-id="element-143">
          Garantía 7 días · Pago seguro · Acceso inmediato
        </p>
      </motion.div>
    </div>
  </section>;
export const Pricing = () => <section id="pricing-section" className="bg-brand-bg py-[48px] px-5 md:px-10" data-id="element-144">
    <div className="max-w-[940px] mx-auto" data-id="element-145">
      <div id="pricing-section" className="flex justify-center mb-[24px] scroll-mt-20" data-id="element-146"></div>

      <h2 className="font-playfair font-bold text-[40px] text-brand-text text-center mb-[8px]" data-id="element-147">
        Elige Tu MegaPack
      </h2>
      <p className="font-inter text-[17px] text-brand-textSec text-center mb-[32px]" data-id="element-148">
        La inversión en tu tranquilidad como padre o madre
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-[24px] items-stretch" data-id="element-149">
        {/* MegaPack 1 */}
        <div className="bg-white border-2 border-brand-borderMedio rounded-[18px] p-[48px_44px] relative flex flex-col order-2 md:order-1 shadow-[0_4px_20px_rgba(15,30,58,0.08)]" data-id="element-150">
          <div className="font-inter font-bold text-[11px] text-brand-textSec tracking-[3px] uppercase mb-[10px]" data-id="element-151">
            MEGAPACK 1
          </div>
          <h3 className="font-playfair font-bold text-[28px] text-brand-text mb-[6px]" data-id="element-152">
            Cómo entender a tu bebé
          </h3>
          <p className="font-inter text-[15px] text-brand-textSec mb-[28px]" data-id="element-153">
            6 Tomos + 6 Bonos
          </p>

          <div className="h-[1px] bg-brand-borderSuave mb-[28px]" data-id="element-154" />

          <ul className="space-y-[12px] flex-grow mb-[32px]" data-id="element-155">
            {['Los 6 Tomos en PDF', 'Los 6 Bonos incluidos', 'Acceso de por vida'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-156">
                <Check className="w-5 h-5 text-brand-accentExtra shrink-0" data-id="element-157" />
                <span className="font-inter text-[15px] text-brand-text" data-id="element-158">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="h-[1px] bg-brand-borderSuave mb-[28px]" data-id="element-159" />

          <div data-id="element-160">
            <div className="font-inter text-[18px] text-brand-textStrikethrough line-through mb-[4px]" data-id="element-161">
              75,76€
            </div>
            <div className="font-playfair font-bold text-[60px] text-brand-text leading-[1] mb-[32px]" data-id="element-162">
              14,97€
            </div>
          </div>

          <button onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'Purchase', {
              value: 14.97,
              currency: 'EUR'
            });
          }
          window.location.href = 'https://checkout.cherubagency.com/cart/56723135103300:1';
        }} className="bg-brand-accent hover:bg-brand-accentHover text-white font-inter font-bold text-[16px] w-full py-[17px] rounded-[10px] shadow-[0_4px_14px_rgba(74,114,184,0.30)] transition-colors" data-id="element-163">
            QUIERO MI MEGAPACK
          </button>
        </div>

        {/* MegaPack Completo */}
        <div className="bg-brand-dark border-2 border-brand-accentPremium rounded-[18px] p-[48px_44px] relative shadow-[0_20px_56px_rgba(15,30,58,0.35)] flex flex-col order-1 md:order-2 transform md:scale-[1.04]" data-id="element-164">
          <div className="absolute -top-[18px] left-1/2 transform -translate-x-1/2 bg-brand-accentPremium text-white font-inter font-bold text-[13px] px-[28px] py-[9px] rounded-[24px] whitespace-nowrap" data-id="element-165">
            ⭐ MÁS ELEGIDO
          </div>

          <div className="font-inter font-bold text-[11px] text-white/45 tracking-[3px] uppercase mb-[10px]" data-id="element-166">
            MEGAPACK COMPLETO
          </div>
          <h3 className="font-playfair font-bold text-[28px] text-white mb-[6px]" data-id="element-167">
            Sistema Completo + Premium
          </h3>
          <p className="font-inter text-[15px] text-white/60 mb-[28px]" data-id="element-168">
            La solución completa para el primer año y más allá
          </p>

          <div className="h-[1px] bg-white/12 mb-[28px]" data-id="element-169" />

          <ul className="space-y-[12px] flex-grow mb-[32px]" data-id="element-170">
            <li className="flex items-start gap-3" data-id="element-171">
              <Check className="w-5 h-5 text-brand-accentExtra shrink-0" data-id="element-172" />
              <span className="font-inter text-[15px] text-white/80" data-id="element-173">
                Los 6 tomos en pdf
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-174">
              <Check className="w-5 h-5 text-brand-accentExtra shrink-0" data-id="element-175" />
              <span className="font-inter text-[15px] text-white/80" data-id="element-176">
                Los 6 bonos incluidos
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-177">
              <Check className="w-5 h-5 text-brand-accentExtra shrink-0 mt-0.5" data-id="element-178" />
              <div className="font-inter text-[15px] text-white/80" data-id="element-179">
                <strong data-id="element-180">DESARROLLO SIN LÍMITES (eBook Premium)</strong>
                <br data-id="element-181" />
                <span className="text-sm text-white/60" data-id="element-182">
                  Cómo despertar la inteligencia de tu bebé desde el primer día
                  (0-2 años)
                </span>
              </div>
            </li>
            <li className="flex items-start gap-3" data-id="element-183">
              <Check className="w-5 h-5 text-brand-accentExtra shrink-0" data-id="element-184" />
              <span className="font-inter text-[15px] text-white/80" data-id="element-185">
                Acceso de por vida
              </span>
            </li>
          </ul>

          <div className="h-[1px] bg-white/12 mb-[28px]" data-id="element-186" />

          <div data-id="element-187">
            <div className="font-inter text-[18px] text-gray-400 line-through mb-[4px]" data-id="element-188">
              157,49€
            </div>
            <div className="font-playfair font-bold text-[60px] text-brand-accentPremium leading-[1] mb-[32px]" data-id="element-189">
              23,97€
            </div>
          </div>

          <button onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'Purchase', {
              value: 23.97,
              currency: 'EUR'
            });
          }
          window.location.href = 'https://checkout.cherubagency.com/cart/56723135856964:1';
        }} className="bg-brand-accentPremium hover:bg-[#C49840] text-white font-inter font-bold text-[17px] w-full py-[18px] rounded-[10px] shadow-[0_6px_20px_rgba(212,168,74,0.45)] hover:shadow-[0_8px_26px_rgba(212,168,74,0.55)] transition-all" data-id="element-190">
            QUIERO EL SISTEMA COMPLETO
          </button>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-[24px] mt-[36px]" data-id="element-191">
        {['Pago 100% seguro', 'Acceso en 5 minutos', 'Garantía 7 días'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-192">
              <Check className="w-4 h-4 text-brand-accentExtra" data-id="element-193" />
              <span className="font-inter text-[14px] text-brand-textSec" data-id="element-194">
                {item}
              </span>
            </div>)}
      </div>
    </div>
  </section>;